export const colours = {
  primaryUI: "#381C50",
  primaryUILight: "#652A58",
  primaryUILighter: "#856D7F",
  secondaryUI: "#CFC5C6",
  greenSpace: "#76AB80",
  offWhite: "#F2EDEE"
}
